/* Awtomic — customer portal click guard. CX-5108.

   Why this exists: layout/theme.liquid renders two global inline scripts (block A at
   :1120-1172, block B at :1173-1234) that hijack every click on `.bundle-button` to
   clear the cart before a Build-a-Box add-to-cart. Neither selector is scoped, so on the
   Awtomic customer portal they cancel the click on Manage, Skip next, Order now, Cancel
   and on the portal sign-in button, and the portal never opens.

   This guard neutralises both blocks ONLY on the customer portal pages, and never on the
   Build-a-Box pages (/tools/bundle-subscriptions/bundle/...), where clearing the cart
   before add-to-cart must keep working.

   It is a workaround on the Awtomic side. When the merchant's developer scopes those two
   theme scripts, this file can be emptied and the guard removed.

   It must load BEFORE the portal buttons render, so the snippet loads it without `async`. */
(function () {
  var path = window.location.pathname;
  var enPortal =
    path.indexOf('/tools/bundle-subscriptions') === 0 &&
    path.indexOf('/tools/bundle-subscriptions/bundle') !== 0;
  if (!enPortal || window.__AWTOMIC_PORTAL_GUARD__) return;
  window.__AWTOMIC_PORTAL_GUARD__ = true;

  var SEL = '.bundle-button, button.bundle-button';

  /* Block B delegates on `document` in the capture phase and returns without cancelling
     when its own allow flag is set. We set it on `window`, which captures first. */
  window.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!btn) return;
      window.__AWTOMIC_BAB_ALLOW_NEXT_CLICK__ = true;
      window.__AWTOMIC_BAB_CLEARING__ = false;
    },
    true
  );

  /* Block A binds the first `.bundle-button` it polls for, unless the element already
     carries `data-cart-clear-bound`. Stamping the portal buttons as they render stops it
     from ever binding, and its 300 ms watcher then stops itself. */
  function marcar(raiz) {
    if (!raiz || raiz.nodeType !== 1) return;
    if (raiz.classList && raiz.classList.contains('bundle-button') && !raiz.dataset.cartClearBound) {
      raiz.dataset.cartClearBound = 'awtomic-portal-guard';
    }
    if (!raiz.querySelectorAll) return;
    var n = raiz.querySelectorAll(SEL);
    for (var i = 0; i < n.length; i++) {
      if (!n[i].dataset.cartClearBound) n[i].dataset.cartClearBound = 'awtomic-portal-guard';
    }
  }

  marcar(document.documentElement);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) marcar(add[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
